import React, { useState } from "react";

const Brand = () => {
  const [agreed, setAgreed] = useState(false);

  return (
    <div className="bg-black w-full min-h-[calc(100vh-120px)] py-12">
      <div className="text-gray-400 font-secondary px-8 max-w-[900px] mx-auto md:px-6 sm:px-4 text-left">
        <h1 className="font-primary text-[2.8rem] text-center mb-10 text-white font-bold md:text-[2.2rem] sm:text-[1.8rem]">
          Brand Guidelines
        </h1>
        
        <section className="mb-10">
          <p className="text-[1.1rem] leading-[1.7] text-gray-500 mb-4 sm:text-[1rem]">
            Effective Date: September 10th, 2025
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            About FOZZIL
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            FOZZIL, the innovator behind cutting-edge AI technologies and systems,
            owns exclusive rights to its trademarks, logos, intellectual property,
            and branding—including the names “FOZZIL,” “ZYPHER AI,” and related
            elements. These guidelines outline how you may properly reference and
            use our brand assets as a valued user or supporter of FOZZIL.
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-400 mb-4 sm:text-[1rem]">
            Note: FOZZIL is an independent company and not affiliated with any
            other organization unless explicitly stated.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Attributing FOZZIL Content
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            If you publish or distribute any text, visuals, or other content
            generated using FOZZIL’s services or platforms, please include a clear
            and legible attribution such as:
          </p>
          <ul className="list-disc pl-8 mt-2 mb-4 text-gray-400">
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">Powered by FOZZIL</li>
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">Created with FOZZIL AI</li>
            <li className="text-[1.1rem] leading-[1.7] mb-2 sm:text-[1rem]">Brought to life using T.A.E.L.S</li>
          </ul>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Media and Press Engagement
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            If you’d like to include FOZZIL in press releases or public-facing
            media, please reach out to us at{" "}
            <a
              href="mailto:legal@fozzil.in"
              className="underline hover:text-blue-400"
            >
              legal@fozzil.in
            </a>{" "}
            for approval. When referencing FOZZIL, kindly identify us as:
          </p>
          <p className="text-[1.1rem] leading-[1.7] text-gray-200 font-medium mb-4 sm:text-[1rem]">
            “FOZZIL is an AI research and development company dedicated to
            building intelligent systems that accelerate progress in General,
            healthcare, scientific exploration, and beyond.”
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Usage Terms
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            The term “Brand Assets” includes FOZZIL’s names, trademarks, service
            marks, logos, product names, icons, and other design elements that
            represent the FOZZIL brand.
            <br />
            By using any FOZZIL Brand Asset, you agree to the following
            conditions:
          </p>
          <div className="flex flex-col md:flex-row gap-8 mb-8 text-gray-300">
            <div className="flex-1">
              <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">You May:</h3>
              <ul className="list-disc pl-8 mt-2 mb-4 text-gray-400">
                <li>
                  Use FOZZIL’s names or logos solely to accurately refer to our
                  company or services.
                </li>
                <li>
                  Adhere to these FOZZIL Brand Guidelines and any future updates
                  we issue.
                </li>
                <li>
                  Make adjustments to your usage of our assets if requested by our
                  legal or brand team.
                </li>
              </ul>
            </div>
            <div className="flex-1">
              <h3 className="text-[1.2rem] font-bold text-gray-200 mt-6 mb-2 sm:text-[0.95rem]">You May Not:</h3>
              <ul className="list-disc pl-8 mt-2 mb-4 text-gray-400">
                <li>
                  Use our brand in a misleading way, or suggest FOZZIL endorses,
                  approves, or is associated with your product, service, or
                  organization without written permission.
                </li>
                <li>
                  Use FOZZIL branding in the name of your app, product, service,
                  business, or domain.
                </li>
                <li>
                  Alter, distort, or modify our logos or combine them with other
                  graphics, symbols, or text.
                </li>
                <li>
                  Use our branding to create a new mark, logo, or brand element.
                </li>
                <li>
                  Use FOZZIL brand elements as part of your own brand identity.
                </li>
              </ul>
            </div>
          </div>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            We reserve the right to revoke any permission to use our brand
            elements at our discretion. If revoked, you must promptly discontinue
            usage.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Logo Use
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            You are permitted to use our official logos only as they are
            provided—unaltered and unedited. Any resizing, recoloring, cropping,
            or stylization of our logos is strictly prohibited.
          </p>
        </section>

        <section className="mb-10 text-left">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white border-b border-gray-800 pb-2 md:text-[1.5rem] sm:text-[1.3rem]">
            Logos
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            By using our logos, you agree to the Usage Terms above and further
            agree to only use our logos exactly as provided at the download link
            below, without any alteration or adjustment.
          </p>
          <div className="mb-4 flex items-center gap-2">
            <input
              type="checkbox"
              id="logo-terms"
              checked={agreed}
              onChange={(e) => setAgreed(e.target.checked)}
              className="w-5 h-5 accent-white bg-black border border-gray-400 rounded"
            />
            <label
              htmlFor="logo-terms"
              className="text-[1.1rem] leading-[1.7] text-gray-300 sm:text-[1rem] select-none"
            >
              By using our logos, you agree to our Marks{" "}
              <a href="#usage-terms" className="underline hover:text-blue-400">
                usage terms
              </a>
              .
            </label>
          </div>
          <a
            href={
              agreed
                ? "https://drive.google.com/uc?export=download&id=1DumUNuGP8QwgqRAEKU8jrA2Z5a3aB5-V"
                : undefined
            }
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-block px-6 py-2 border border-white rounded-full text-lg font-mono tracking-widest text-white transition-colors duration-200 mb-10 ${
              agreed
                ? "hover:bg-white hover:text-black cursor-pointer"
                : "opacity-50 cursor-not-allowed pointer-events-none"
            }`}
            download={agreed ? true : undefined}
          >
            DOWNLOAD OUR LOGOS
          </a>
        </section>

        <section className="mb-10 text-center border-t border-gray-800 pt-10">
          <h2 className="font-primary text-[1.8rem] mb-5 text-white md:text-[1.5rem] sm:text-[1.3rem]">
            Contact FOZZIL
          </h2>
          <p className="text-[1.1rem] leading-[1.7] text-gray-300 mb-4 sm:text-[1rem]">
            For brand, legal, or usage questions, reach out to{" "}
            <a
              href="mailto:legal@fozzil.in"
              className="underline hover:text-blue-400 text-blue-400"
            >
              legal@fozzil.in
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Brand;
